import debounce from 'debounce-promise';

import appSettings from 'wanderu-config';
import Logger from 'wanderu-logger';
import { SnowplowService } from 'wanderu-service-analytics';
import GoogleService, { NoResultsError } from 'wanderu-service-google';

import { actions as googleDataActions } from '../../appstate';
import { serializePredictionParams } from '../utils';
import {
    actions,
    namespace,
    reducer,
    selectors,
} from './base';

const logger = Logger.getLogger('wanderu-duck-google:fetchPlacePredictions');
const debouncedGetPlacePredictions = debounce(GoogleService.getPlacePredictions, 175);

export function fetch(opts) {
    return async (dispatch, getState) => {
        const id = serializePredictionParams(opts);
        const hasFetched = selectors.selectSuccess(getState(), id);
        const isFetching = selectors.selectWorking(getState(), id);
        if (hasFetched || isFetching) {
            return;
        }

        dispatch(actions.startWork(id));

        let error;
        let meta;
        let response;
        try {
            if (opts.debounce) {
                response = await debouncedGetPlacePredictions(opts.input, {
                    locale: opts.locale,
                    meta: opts.meta,
                    v2: opts.v2,
                });
            } else {
                response = await GoogleService.getPlacePredictions(opts.input, {
                    locale: opts.locale,
                    meta: opts.meta,
                    v2: opts.v2,
                });
            }

            return dispatch(googleDataActions.setPredictions(id, response));
        } catch (ex) {
            if (!ex instanceof NoResultsError) {
                const domainUserInfo = appSettings.env.isClient
                    ? SnowplowService.getDomainUserInfo()
                    : {};

                logger.error('fetch', ex, {
                    snowplowIds: {
                        networkUserId: SnowplowService.getNetworkUserId(),
                        ...domainUserInfo,
                    },
                });
            }
            error = {
                code: ex.code,
                message: ex.message,
                name: ex.name,
            };
        } finally {
            dispatch(actions.endWork(id, meta, error));
        }
    };
}

const fetchPlacePredictionsAction = {
    fetch,
    ...selectors,
};

export {
    fetchPlacePredictionsAction,
};

export default {
    [namespace]: reducer,
};
